// @author: suthzy
// @date: 01-09-2023
// @description: A simple logging utility to log to console based on the mode set in config

import config from "../app/utils/config";

const logman = {
        debug: (message) => {
            if (config.mode.debug) {
                console.debug('DEBUG::', message);
            }
        },
        warn: (message) => {
            if (config.mode.warn) {
                console.warn('WARN::', message);
            }
        },
        error: (message) => {
            if (config.mode.error) {
                console.error('ERROR::', message);
            }
        },
        info : (message) => {
            if (config.mode.info) {
                console.info('INFO::', message);
            }
        }
}

export default logman;